import type { WorkerSchema } from '../types'
import { normalizeIconKey, type IconKey } from './iconRegistry'

export const EMOJI_ICON_MAP: Record<string, IconKey> = {
  '💰': 'wallet',
  '💸': 'receipt',
  '📅': 'calendar',
  '📦': 'package',
  '💬': 'message-circle',
  '💼': 'briefcase',
}

export const WORKER_ID_ICON_MAP: Record<string, IconKey> = {
  'bill-lin-income': 'wallet',
  'bill-lin-expense': 'receipt',
  'nad-dee': 'calendar',
  'song-dee': 'package',
  'erin': 'message-circle',
}

export function stripWorkerLabelEmoji(label: string) {
  return label.replace(/^[^\p{L}\p{N}]+/u, '').trim()
}

export function getLeadingEmoji(label: string) {
  const trimmed = label.trim()
  const match = trimmed.match(/^[^\p{L}\p{N}\s]+/u)
  return match?.[0] ?? null
}

export function resolveWorkerIconKey(input: {
  workerId: string
  workerLabel: string
  tabIcon?: string
}): IconKey {
  const schemaIcon = normalizeIconKey(input.tabIcon)
  if (schemaIcon) return schemaIcon

  const leadingEmoji = getLeadingEmoji(input.workerLabel)
  if (leadingEmoji && EMOJI_ICON_MAP[leadingEmoji]) {
    return EMOJI_ICON_MAP[leadingEmoji]
  }

  return WORKER_ID_ICON_MAP[input.workerId] ?? 'briefcase'
}

export function normalizeWorkerTab(schema: WorkerSchema) {
  return {
    id: schema.workerId,
    label: stripWorkerLabelEmoji(schema.workerLabel),
    iconKey: resolveWorkerIconKey(schema),
  }
}
